module.exports = __webpack_public_path__ + "img/notRanked.bc4b2da6.svg";